"use client";
import styles from "./index.module.scss";
import MoreIcon from "@/assets/icons/more.svg";
import cn from "clsx";

import { useEffect, useRef, useState } from "react";
import { useTranslation } from "@/i18n/client";

export const AutoFold = ({ children }: any) => {
  const {t} = useTranslation();
  const [moreBtnShow, setMoreBtnShow] = useState(false);
  const [isFold, setIsFold] = useState(true);
  const childrenRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setMoreBtnShow((childrenRef.current?.clientHeight || 0) > 180);
  }, []);

  return (
    <>
      <div className={cn(styles.autoFoldWrapper, !isFold && styles.unfold)}>
        <div ref={childrenRef}>{children}</div>
      </div>
      {moreBtnShow && (
        <div
          className={styles.foldBtn}
          onClick={() => {
            setIsFold((isFold) => !isFold);
          }}
        >
          {isFold ? (
            <>
              {t("common.btnText.more")} <MoreIcon width={16} height={10} />
            </>
          ) : (
            <>
              {t("common.btnText.retract")} <MoreIcon width={16} height={10} className={styles.svgExpand} />
            </>
          )}
        </div>
      )}
    </>
  );
};
